export default "__VITE_ASSET__DchrZ8dR__"